// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36wmy","select":"styles_select__1sZj6"};